const options = {
  5: "bg-fuchsia-700/5",
  10: "bg-fuchsia-700/10",
  25: "bg-fuchsia-700/25",
  50: "bg-fuchsia-700/50",
  75: "bg-fuchsia-700/75",
  90: "bg-fuchsia-700/90",
  100: "bg-fuchsia-700",
};

const from = {
  5: "from-fuchsia-700/5",
  10: "from-fuchsia-700/10",
  25: "from-fuchsia-700/25",
  50: "from-fuchsia-700/50",
  75: "from-fuchsia-700/75",
  90: "from-fuchsia-700/90",
  100: "from-fuchsia-700",
};

export default function getBackgroundFuchsia700(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
